// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manage-groups-main{
    padding: 13px 0px 20px;
    height: calc(100vh - 73px);
    overflow-y: hidden;
}

 .stop-btn{
    background-color: var(--main-color);
    border: none;
    border-radius:22px ;
    padding: 10px 22px;
    color: white;
    font-weight: bold;
    margin-top: 10px;
    cursor: pointer;
}

.stop-btn:hover{
    opacity: .9;
}`, "",{"version":3,"sources":["webpack://./src/Pages/ManageGrousp/managegroups.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,0BAA0B;IAC1B,kBAAkB;AACtB;;CAEC;IACG,mCAAmC;IACnC,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf","sourcesContent":[".manage-groups-main{\n    padding: 13px 0px 20px;\n    height: calc(100vh - 73px);\n    overflow-y: hidden;\n}\n\n .stop-btn{\n    background-color: var(--main-color);\n    border: none;\n    border-radius:22px ;\n    padding: 10px 22px;\n    color: white;\n    font-weight: bold;\n    margin-top: 10px;\n    cursor: pointer;\n}\n\n.stop-btn:hover{\n    opacity: .9;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
